(ns frontend.ui.component.lp-portal.report.body.lifeline.holding.web 
  (:require
   [common.util :as cu]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.report.component.image.view :as image]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]
   [frontend.ui.component.lp-portal.voima-components.badge.view :as badge]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.rich-text-editor.core :as rich]
   [frontend.ui.component.rich-text-editor.view :as rich-text-editor]
   [frontend.ui.component.table.view :as table]
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]))

(defn company-information
  [{:keys [company-information]} props]
  [:div {:style {:background-color (theme/color [:palette :granite])
                 :border-radius    "15px"}}
   [table/editable-table company-information props
    (vertical-table/table "Company" company-information (merge props {:hide-footnote?   true
                                                                      :stacked-rows?    true
                                                                      :background-color (theme/color [:palette :granite])
                                                                      :text-color       (theme/color [:palette :white])
                                                                      :expanded-title-color (theme/color [:palette :black])
                                                                      :title-color      (theme/color [:palette :white])}))]])

(defn investment-information
  [{:keys [investment-information]} props]
  [:div
   [table/editable-table investment-information props
    [vertical-table/table "Investment" investment-information (merge props {:hide-footnote? true
                                                                            :fixed-width? true})]]])

(defn financials-table
  [{:keys [financials-table]} props]
  [:div
   [table/editable-table financials-table props
    [vertical-table/table "Financials" financials-table (merge props {:hide-footnote? true})]]])

(defn latest-transactions
  [{:keys [latest-transactions]} props]
  [:div
   [horizontal-table/table "Latest transactions" latest-transactions props]])

(defn writing-instructions-panel
  [writing-instructions props]
  (let [edit-enabled? (:report-admin? props)
        show-alert? (or (:edit-mode? props)
                        edit-enabled?)]
    (when show-alert?
      [:div
       {:class-name "mb-3 rounded-lg border border-dashed border-slate-400 bg-white px-3 py-2.5 text-[13px]"}
       [:div {:class-name "mb-2 flex items-center gap-2"}
        [:span {:class-name "inline-flex h-5 w-5 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-700"}
         "!"]
        [:div {:class-name "font-semibold"}
         "General writing instructions (not visible in the report)"]]
       (if edit-enabled?
         [free-text-card/free-text
          writing-instructions
          (assoc props
                 :edit-mode? true
                 :save-text (:save-fund-text props))]
         (let [editor-state (rich/init-state (:rich-content writing-instructions))]
           [rich-text-editor/rich-text-editor
            {:read-only? true
             :border?    false}
            editor-state]))])))

(defn lifeline-holding-header
  [{:keys [holding-name logo-image cross-fund-investment?]} props]
  (let [holding-template-type (:holding-template-type props)
        exited? (= :lp-report-holding-template.lifeline/exited-holding holding-template-type)]
    [:div
     {:style {:display         "flex"
              :flex-wrap       "wrap"
              :justify-content "space-between"
              :align-items     "flex-start"
              :column-gap      "1rem"
              :row-gap         "0.75rem"
              :width           "100%"}}
     [:div
      {:style {:display     "flex"
               :flex        "1 1 320px"
               :min-width   "0"
               :flex-wrap   "wrap"
               :align-items "center"
               :gap         "0.75rem"}}
      [:div {:class (<class style/holding-header)
             :style {:white-space "normal"
                     :min-width "0"
                     :overflow-wrap "anywhere"}}
       holding-name]
      (if exited?
        [badge/badge
         {:variant :exited-investment
          :pill?   false}
         "Exited"]
        [badge/badge
         {:variant :portfolio-company
          :pill?   false}
         "Portfolio company"])
      (when cross-fund-investment?
        [badge/badge
         {:variant :portfolio-company
          :pill?   false}
         "Cross-fund investment"])]
     [:div
      {:style {:flex "0 0 auto"
               :margin-left "auto"
               :max-width "250px"}}
      [image/image
       (if (cu/blank-value? (:image logo-image)) "Add company logo" "")
       logo-image
       (merge props
              {:hide-footnote?     true
               :min-zoom           0.2
               :logo-target-height 50
               :logo-target-width  140})
       true]]]))

(defn company-section
  [holding-ui-data props]
  (let [{:keys [description significant-events]} holding-ui-data
        writing-instructions (get-in props [:fund-ui-data :writing-instructions])]
    [section/portfolio-section
     ""
     (str "company-section-"
          (some->> props :report :db/id))
     [:div
      [:div {:class (<class style/section-wrapper)}
       [lifeline-holding-header
        holding-ui-data
        props]
       [card/card
        {:title ""
         :background-color (theme/color [:palette :granite])}
        [:div
         [writing-instructions-panel writing-instructions props]
         [free-text-card/free-text-section
          "Description"
          description
          props]
         [free-text-card/free-text-section
          "Significant events"
          significant-events
          props]]
        [company-information holding-ui-data props]]
       [grid/row {}
        [grid/column {:large 6}
         [investment-information holding-ui-data props]]
        [grid/column {:large 6}
         [financials-table holding-ui-data props]
         [latest-transactions holding-ui-data props]]]]]]))

(defn view
  [{:keys [holding-ui-data] :as props}]
  [:div
   {:id (str "holding-report-" (:report-id holding-ui-data))}
   [company-section holding-ui-data props]])
